import React from "react";

const UserIcon = ({ width = 85, height = 85, fill = "#787882", className }) => {
    return (
        <svg
            width={width}
            height={height}
            class="svg-icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path fill={fill} class="st0" d="M658.7,350.6c0-89-69.9-161.1-156.1-161.1s-156.1,72.1-156.1,161.1s69.9,161.1,156.1,161.1
	C588.9,511.7,658.7,439.6,658.7,350.6 M877.3,861.7c1,3.5,1.7,7.1,1.7,10.9c0,20.9-16.4,38-36.7,38c-20.2,0.1-36.6-16.9-36.7-38
	c0,0,0,0,0,0v-0.1h-1C795.2,713.6,668,587.7,512,587.7c-156,0-283.3,125.9-292.9,284.8h-0.8v0.1c0,20.9-16.4,38-36.7,38
	c-20.2,0.1-36.6-16.9-36.7-37.9c0,0,0,0,0,0c0-3.6,0.6-7,1.5-10.3c10.7-144.2,98.7-265.9,221.7-320.1
	c-57.1-43.1-94.5-112.8-94.5-191.6c0-131,102.7-237.2,229.3-237.2c126.7,0,229.3,106.2,229.3,237.2c0,73.2-32.7,142.3-88.5,186.9
	C772.7,589,866.1,713.3,877.3,861.7"/>
        </svg>
    );
};

export default UserIcon;
